const list = {
  path: 'agentbanner',
  component: resolve => require(['@/pages/admin/businessmag/agentbanner'], resolve)
}

export default list
